export const UploadIcon = ({ fileName }: { fileName: string }) => {
  return (
    <div className='flex w-12 items-center justify-center'>
      <div className='text-primary dark:bg-secondary-50/10 rounded bg-sky-100 p-1 text-sm'>
        {fileName.split('.').reverse()[0].toUpperCase()}
      </div>
    </div>
  );
};
